export default __webpack_public_path__ + "static/halcyon-black-3148a9a7ab5f0b0bd6b31907c42dbce9.woff";